import { createContext } from 'react';

import type { ProjectConfigOutput } from '#schema/ProjectConfigSchema';

export interface ProjectContextProps {
  config: ProjectConfigOutput;
}

export const ProjectContext = createContext<ProjectContextProps>({} as ProjectContextProps);
